import c from "./Sidebar.module.scss";
import ItemCustomization from "../plan-copy/ItemCustomization";
import "overlayscrollbars/overlayscrollbars.css";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { useState } from "react";
import { cn } from "../../lib/utils";
import LoadingBox from "../loading/LoadingBox";
import CloneContentModal from "../popups/plan-content-presets-copy/CloneContentPopup";
import usePlanContentPresetsCopy from "../../hooks/plan-content-presets-copy.hook";
import { getTemplatesPlansContentPresetImportConfiguration } from "../../services/plans-template-content-preset-import-configuration.service";

function Sidebar({ configurations, disableCreate }) {
	const {
		setCrudConfOpen,
		selectedConfId,
		updateSelectedConf,
		setDeleteModalOpen,
		setDeleteConf,
		setDeleteItem,
		deleteConfigurationHandler,
		setCrudModel,
		planData,
		loadingCopyPlan,
	} = usePlanContentPresetsCopy();

	const [loadingEdit, setLoadingEdit] = useState(false);

	const [cloneConfigurationModel, setCloneConfigurationModel] = useState({
		isOpen: false,
		item: null,
	});

	/**
	 * Delete item request
	 * @param {*} item
	 */
	const deleteItem = (item) => {
		setDeleteItem(item);
		setDeleteConf({
			title: "Elimina configurazione",
			icon: "icon_16 default folder",
			subtitle: item.title,
			confirmHandler: deleteConfigurationHandler,
		});
		setDeleteModalOpen(true);
	};

	/**
	 * Edit item request
	 * @param {*} item
	 */
	const editItem = async (item) => {
		if (!loadingEdit) {
			setLoadingEdit(true);

			const copier = await getTemplatesPlansContentPresetImportConfiguration({
				templatePlan: planData.template_plan_id,
				contentPreset: planData.content_preset_id,
				importConfiguration: item.id,
			});

			setLoadingEdit(false);
			setCrudModel(copier.data);
			setCrudConfOpen(true);
		}
	};

	/**
	 * new item request
	 * @param {*} item
	 */
	const newItem = () => {
		setCrudModel(null);
		setCrudConfOpen(true);
	};

	return (
		<div className={c.main_sidebar}>
			<div className={c.wrap_sidebar}>
				{/* Header Sidebar */}
				<div className={c.main_header_sidebar}>
					<div className="fade_in">
						<div className={c.main_title}>
							<div className={c.title}>Seleziona il contenuto da copiare</div>
						</div>

						<div className={c.main_item}>
							<ItemCustomization
								onChange={() => updateSelectedConf(null)}
								checked={selectedConfId == null}
								id="copy_all_plan"
								name="conf_choice"
								label="Tutto il contenuto"
							/>
						</div>
					</div>
				</div>

				<div className={cn(c.main_content_sidebar, "fade_in")}>
					<div className={c.main_heading}>
						<div className={c.main_title}>
							<div className={c.title}>Configurazioni di copia</div>
						</div>

						<div className={c.main_action}>
							<button
								type="button"
								onClick={() => !disableCreate && newItem()}
								className={
									"link-interactive flex items-center gap-2" +
									(disableCreate ? " link_disabled" : "")
								}
								{...(disableCreate && {
									"data-tooltip-id": "tooltip_small_top",
									"data-tooltip-offset": 10,
									"data-tooltip-content": "Nessun contenuto da copiare",
								})}
							>
								<span className="icon_16 plus default icon_mask !bg-interactive-100 -mt-1"></span>
								Crea
							</button>
						</div>
					</div>

					<OverlayScrollbarsComponent className={c.main_list_item}>
						<div className={c.wrap_list_item}>
							{loadingCopyPlan.copiers ? (
								<LoadingBox blocked="true" />
							) : (
								configurations.map((conf, i) => (
									<ItemCustomization
										key={i}
										onChange={() => updateSelectedConf(conf.id)}
										checked={String(selectedConfId) === String(conf.id)}
										id={`copy_item_${conf.id}`}
										name="conf_choice"
										label={conf.title}
										onDuplicate={() => setCloneConfigurationModel({ isOpen: true, item: conf })}
										onEdit={() => editItem(conf)}
										onDelete={() => deleteItem(conf)}
									/>
								))
							)}
						</div>
					</OverlayScrollbarsComponent>
				</div>
			</div>
			<CloneContentModal
				open={cloneConfigurationModel.isOpen}
				model={cloneConfigurationModel.item}
				setOpen={() => setCloneConfigurationModel((old) => ({ ...old, isOpen: false }))}
			/>
		</div>
	);
}

export default Sidebar;
